/* eslint-disable */
import React from 'react';
import GhostButton from '../../../GhostButton/GhostButton';
import { StyledMobileImageContainer } from './MobileFrame.styles';
import SocialIcons from '../../../SocialIcons';

type PropsType = {
  title: string;
  subTitle?: string;
  buttonText?: string;
};
const MobileFrame: React.FC<PropsType> = (props) => {
  return (
    <StyledMobileImageContainer>
      <div className="inner-container">
        <div className="text-container">
          <div>
            <p className="title-text">{props.title}</p>
          </div>
          <div className="sub-text-container">
            <p className="sub-text">{props.subTitle}</p>
            <GhostButton>{props.buttonText}</GhostButton>
          </div>
        </div>
        <SocialIcons className='social-media-container' />
      </div>
    </StyledMobileImageContainer>
  );
};

export default MobileFrame;
